import type { CidString } from '@wovin/core'
import type { SnapBlockLogsOrChunks } from '@wovin/core'
import type { Pair } from 'helia'
import { getDecodedBlock, parseCID, unchunkApplogsBlock } from '@wovin/core'
import { Logger } from 'besonders-logger'
import { CID } from 'multiformats'
import { getBlockStore } from './blockStore'

const { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.INFO) // eslint-disable-line unused-imports/no-unused-vars

/** Walks the snapshot DAG in IDB to collect applog CIDs.
 * Assumes the full DAG is present — callers must handle missing-block errors
 * (root block in IDB does NOT guarantee the full DAG is present). */
export async function getApplogCIDsFromPubInBlockStore(pubCID: CID | CidString, pub?: any) {
	pub = pub ?? (await getBlockFromStore(pubCID)) as any
	if (!pub) throw ERROR(`Pub not found in local BlockStore`, pubCID.toString())
	const applogsBlock = (await getBlockFromStore((pub as any).applogs)) as SnapBlockLogsOrChunks
	const logCIDs = await unchunkApplogsBlock(applogsBlock, getBlockStore())
	return logCIDs
	// 	.map(blockCID => {
	// 	const log = getApplogDB().getApplog(blockCID)
	// 	if (!log) throw ERROR(`Log from local publication snapshot not in local applog DB`, { cid: pubCID, blockCID })
	// 	return log
	// })
}

export async function addBlocksToStore(blocksToStore: Pair[]) {
	for await (
		const cid of getBlockStore().putMany(
			blocksToStore,
		)
	) {
		VERBOSE(`[blockStore] put`, cid.toString())
	}
}
export async function getBlockFromStore(cid: CID | CidString) {
	return await getDecodedBlock(getBlockStore(), typeof cid === 'string' ? parseCID(cid) : cid)
}
